module.exports = __webpack_public_path__ + "media/images/emblems/Affoltern_im_Emmental-coat_of_arms-088b753be03761e75b93bc4daa797361.svg";